import {
    HelpSupportListResolver,
    HelpsupportEditResolver,
    HelpSupportUserListResolver
} from './services/help-support.resolver.service';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelpSupportListComponent } from './components/help-supportList.component';
import { CreateHelpSupportComponent } from './components/Createhelp-support.component';
import { HelpSupportUserListComponent } from './components/help-supportUserList.component';
import { HelpSupportTabsComponent } from './components/help-support-tabs.component';
import { HelpSupportComponent } from './help-support.component';
import { HelpSupportServices } from './services/help-support.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { ConfirmationService, SharedModule } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ContextMenuModule} from 'primeng/contextmenu';
import {TabsModule} from 'primeng/tabs';
import {MenuModule} from 'primeng/menu';
import { AppSharedModule } from '../shared/appShared.module';
@NgModule({ declarations: [HelpSupportComponent, HelpSupportListComponent, CreateHelpSupportComponent, HelpSupportUserListComponent, HelpSupportTabsComponent],
    imports: [
        BrowserModule,
        RouterModule,
        SharedModule,
        FormsModule,
        DatePickerModule,
        EditorModule,
        ReactiveFormsModule,
        ContextMenuModule,
        MenuModule,
        ConfirmDialogModule,
        SelectModule,
        TranslatePipe, TranslateDirective,
        DialogModule,
        TabsModule,
        AppSharedModule
    ],

    providers: [
        HelpSupportServices,
        ConfirmationService,
        HelpSupportListResolver,
        HelpsupportEditResolver,
        HelpSupportUserListResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class HelpSupportModule {}
